var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',[_c('CirclePlaceholder',{attrs:{"partnerInitials":_vm.initials,"color":"dark"}}),_c('div',{staticClass:"cirlce-title"},[_vm._v(" "+_vm._s(_vm.$t("visits.video.noPartner"))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }